import * as React from 'react';

const gridCellCopyStyle = 'border:1px solid #dee2e6;padding:8px;color:#212529;background-color:#ffffff;font:12px/1.5 Arial,sans-serif;vertical-align:middle;';

export const copyGridSelection = (e: React.ClipboardEvent) => {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed || selection.rangeCount === 0) return;

  const fragment = document.createElement('div');
  for (let i = 0; i < selection.rangeCount; i++) {
    fragment.appendChild(selection.getRangeAt(i).cloneContents());
  }

  if (fragment.querySelectorAll('td,th').length === 0) return;

  if (!fragment.querySelector('table')) {
    fragment.innerHTML = fragment.querySelector('tr')
      ? `<table><tbody>${fragment.innerHTML}</tbody></table>`
      : `<table><tbody><tr>${fragment.innerHTML}</tr></tbody></table>`;
  }

  fragment.querySelectorAll<HTMLElement>('*').forEach((el) => {
    el.removeAttribute('class');
    el.removeAttribute('style');
  });
  fragment.querySelectorAll<HTMLElement>('table').forEach((el) => el.setAttribute('style', 'border-collapse:collapse;color:#212529;background-color:#ffffff;'));
  fragment.querySelectorAll<HTMLElement>('td,th').forEach((el) => el.setAttribute('style', gridCellCopyStyle));
  fragment.querySelectorAll<HTMLElement>('a').forEach((el) => el.setAttribute('style', 'color:#1355A2;'));

  e.clipboardData.setData('text/html', fragment.innerHTML);
  e.clipboardData.setData('text/plain', selection.toString());
  e.preventDefault();
};
